import { createApi } from '@reduxjs/toolkit/query/react';

import { axiosBaseQuery } from 'api/axiosBaseQuery';

export const rtkApi = createApi({
  reducerPath: 'rtkApi',
  baseQuery: axiosBaseQuery(),
  endpoints: () => ({}),
  tagTypes: [
    'CourseDirection',
    'Level',
    'Labels',
    'Paywall',
    'GiftBox',
    'GiftAct',
    'Products',
    'Promotions',
    'Promocodes',
    'PromotionFactors',
    'DietGroups',
    'PhotoList',
    'PdfList',
    'Diets',
    'Video',
    'Course',
    'Order',
    'Achievements',
    'UserActivityHistory',
    'Downloads',
    'Story',
    'WorkoutsList',
    'CourseComments',
    'MarathonReviews',
    'MarathonReviewComplaints',
    'MarathonComments',
    'MarathonCommentComplaints',
    'MarathonProducts',
    'Bads',
    'BadPage',
    'BadPromocodes',
    'CarrotSends',
    'CommentsComplaints',
    'Users',
    'Player',
    'GPlayer',
    'AuthMethods',
    'Marathons',
    'MarathonTemplate',
    'Widgets',
    'MarathonFeedPost',
    'MarathonWorkouts',
    'Groups',
    'ReferralRules',
    'AppFilter',
    'AppSearch',
    'FeatureFlag',
    'UserRetention',
  ],
});
